import Link from 'next/link'

import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  width,
  WidthProps,
} from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps>`
  display: flex;
  justify-content: space-between;
  gap: ${themeGet('space.11')}px;

  ${flexDirection}
`

export const StyledLink = styled(Link)`
  color: ${themeGet('colors.text.link')};

  > span {
    color: inherit;
  }

  &:hover {
    color: ${themeGet('colors.text.linkHover')};
  }
`

export const ImageHolder = styled.div.withConfig({
  shouldForwardProp,
})<WidthProps>`
  display: flex;
  height: 64px;

  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }

  ${width}
`
